import {useRef, useEffect} from 'react';

export const useInitalFocus = () => {
    const inputRef = useRef<HTMLInputElement>(null);
    useEffect(() => {
        setTimeout(() => {
            inputRef.current?.focus();
        }, 100);
    }, []);
    return inputRef;
};
